import { useState } from 'react';

export const useFAQViewModel = () => {
  const [openId, setOpenId] = useState(null);

  const toggleQuestion = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return { openId, toggleQuestion };
};
